export default class DateUtils {
  public static ts2datestring = (t: number) => new Date(t).toLocaleDateString();
}
